import { device } from '@src/common/breakpoints';
import { LayoutColors } from '@src/core/theme';
import { BodyRegularSemiBold } from '@src/fonts/typography/Typography';
import styled from 'styled-components';

export const ExpiredSales = styled.div``;

export const PaymentMethods = styled.div`
  display: flex;
  flex-flow: column;
`;

interface PaymentMethodProps {
  $isSelected: boolean;
}

interface PaymentFormsProps {
  $showResume: boolean;
}

export const PaymentContainer = styled.div`
  width: 100%;
  max-width: 1095px;
  height: auto;
  border-radius: 8px;
  padding: 16px;
  background-color: ${LayoutColors.whiteDark};
  margin: auto;
  display: flex;
  flex-direction: column;
  gap: 40px;

  ${device.mediumTablet} {
    padding: 24px;
  }
`;

export const ContainerBody = styled.div`
  display: flex;
  width: 100%;
  gap: 0 16px;
`;

export const PaymentForms = styled.div<PaymentFormsProps>`
  ${(props) => (props.$showResume ? 'max-width: 733px;' : '')}

  width: 100%;
  position: relative;
  ${device.mediumTablet} {
    ${(props) => (props.$showResume ? 'width: calc(100% - 298px);' : '')}
  }
`;

export const PaymentFormsContainer = styled.div`
  width: 100%;
  height: auto;
  position: relative;
`;

export const MethodHead = styled.div`
  display: flex;
  flex-flow: column;
  gap: 8px;

  ${device.smallTablet} {
    flex-flow: row;
  }
`;

export const Method = styled.button<PaymentMethodProps>`
  ${BodyRegularSemiBold};
  width: 100%;
  height: 44px;
  border-radius: 4px;
  text-align: center;
  background-color: ${(props) => (props.$isSelected ? LayoutColors.justBlue : 'transparent')};
  border: 1px solid ${LayoutColors.justBlue};
  color: ${(props) => (props.$isSelected ? LayoutColors.whiteLight : LayoutColors.justBlue)};
  cursor: pointer;
`;

export const MethodBody = styled.div`
  margin-top: 16px;
  border: 1px solid #cdcdcd;
  border-radius: 4px;
  padding: 16px;
`;

export const PhoneVerificationBody = styled.div`
  margin-top: 16px;
`;

export const LoadingCardPayment = styled.div`
  width: 82px;
  height: 82px;
  border-radius: 100%;
  border: 5px solid ${LayoutColors.justBlue};
  border-bottom-color: rgba(0, 0, 0, 0);
  animation: Rotate 0.5s linear infinite;
  z-index: 999999999;
  position: absolute;
  left: calc(50% - 41px);
  top: calc(50% - 41px);
  @keyframes Rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;
